import HttpErrorResponseModel from 'models/HttpErrorResponseModel';
import ActionUtility from '../../utilities/ActionUtility';
import { ReduxDispatch } from 'models/ReduxProps';
import IStore from 'models/IStore';
import PersonResponse from './models/PersonResponse';
import RecipientEffect from './RecipientEffect';

type ActionUnion = undefined | HttpErrorResponseModel | PersonResponse;

export default class RecipientAction {
    public static readonly REQUEST_DO_PHYSICAL_NATIONAL_FXN: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN';
    public static readonly REQUEST_DO_PHYSICAL_NATIONAL_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN_FINISHED';

    public static readonly REQUEST_DO_PHYSICAL_INTERNATIONAL_FXN: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN';
    public static readonly REQUEST_DO_PHYSICAL_INTERNATIONAL_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN_FINISHED';

    public static readonly REQUEST_DO_MORAL_NATIONAL_FXN: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN';
    public static readonly REQUEST_DO_MORAL_NATIONAL_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN_FINISHED';

    public static readonly REQUEST_DO_MORAL_INTERNATIONAL_FXN: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN';
    public static readonly REQUEST_DO_MORAL_INTERNATIONAL_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN_FINISHED';

    public static readonly REQUEST_DO_GET_DATA_RECIPIEN_FXN: string = 'ChallengeAction.REQUEST_DO_GET_DATA_RECIPIEN_FXN';
    public static readonly REQUEST_DO_GET_DATA_RECIPIEN_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_GET_DATA_RECIPIEN_FXN_FINISHED';
    public static readonly SET_EMPTY_DATA_RECIPIENT: string = 'ChallengeAction.SET_EMPTY_DATA_RECIPIENT';

    public static readonly REQUEST_DO_DELETE_RECIPIEN_FXN: string = 'ChallengeAction.REQUEST_DO_DELETE_RECIPIEN_FXN';
    public static readonly REQUEST_DO_DELETE_RECIPIEN_FXN_FINISHED: string = 'ChallengeAction.REQUEST_DO_DELETE_RECIPIEN_FXN_FINISHED';

    public static readonly SET_QUERY_STRING: string = 'ChallengeAction.SET_QUERY_STRING';
    public static readonly SET_CURRENT_TRANSACTION: string = 'ChallengeAction.SET_CURRENT_TRANSACTION';
    public static readonly SET_TRANSACTION_ONINIT: string = 'ChallengeAction.SET_TRANSACTION_ONINIT';
    public static readonly SET_COUNTER: string = 'ChallengeAction.SET_COUNTER';

    public static readonly CODES_RETURN: string[] = ['BDR002', 'BDR003', 'BDR004', 'BDR005', 'BDR092', 'BDR102', 'DEST-401'];

    static SetQueryString(query: any): any {
        return ActionUtility.createAction(RecipientAction.SET_QUERY_STRING, query);
    }

    public static SetCurrentTransaction(value: string): any {
        return ActionUtility.createAction(RecipientAction.SET_CURRENT_TRANSACTION, value);
    }

    public static requestDoPhysicalNational(params: any, opKey: string, token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                sig: params.sig,
                app: params.app,
                opk: opKey,
                token: token,
                jwt: params.jwt,
                tpp: params.tpp,
                tpc: params.tpc,
                cry: params.cry,
                acc: params.acc,
                ali: params.ali,
                nam: params.nam,
                apa: params.apa,
                ama: params.ama,
                ban: params.ban,
                ema: params.ema,
                tba: params.tba,
                ttx: params.ttx,
                trk: params.trk,
                cba: params.cba,
            };
            await ActionUtility.createThunkEffect<PersonResponse>(
                dispatch,
                RecipientAction.REQUEST_DO_PHYSICAL_NATIONAL_FXN,
                RecipientEffect.requestDoPhysicalNational,
                objReq
            ).then((data: any) => {
                this.redirectRegistration(data, params, getState);
            });
        };
    }

    public static requestDoPhysicalInternational(params: any, opKey: string, token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                sig: params.sig,
                app: params.app,
                opk: opKey,
                token: token,
                jwt: params.jwt,
                tpp: params.tpp,
                tpc: params.tpc,
                cry: params.cry,
                acc: params.acc,
                ali: params.ali,
                nam: params.nam,
                apa: params.apa,
                ama: params.ama,
                ban: params.ban,
                ema: params.ema,
                tba: params.tba,
                cba: params.cba,
                stn: params.stn,
                rou: params.rou,
                sbl: params.sbl,
                aal: params.aal,
                ale: params.ale,
                cou: params.cou,
                tci: params.tci,
                cbi: params.cbi,
                tbi: params.tbi,
                ain: params.ain,
                trk: params.trk,
                ttx: params.ttx,
                nac: params.nac,
                suc: params.suc,
                cpo: params.cpo,
                con: params.con,
            };
            await ActionUtility.createThunkEffect<PersonResponse>(
                dispatch,
                RecipientAction.REQUEST_DO_PHYSICAL_INTERNATIONAL_FXN,
                RecipientEffect.requestDoPhysicalInternational,
                objReq
            ).then((data: any) => {
                this.redirectRegistration(data, params, getState);
            });
        };
    }

    public static requestDoMoralNational(params: any, opKey: string, token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                sig: params.sig,
                opk: opKey,
                token: token,
                jwt: params.jwt,
                app: params.app,
                tpp: params.tpp,
                tpc: params.tpc,
                cry: params.cry,
                acc: params.acc,
                ali: params.ali,
                raz: params.raz,
                ban: params.ban,
                ema: params.ema,
                cba: params.cba,
                mmt: params.mmt,
                tre: params.tre,
                tba: params.tba,
                trk: params.trk,
                ttx: params.ttx,
                rfc: params.rfc,
            };
            await ActionUtility.createThunkEffect<PersonResponse>(
                dispatch,
                RecipientAction.REQUEST_DO_MORAL_NATIONAL_FXN,
                RecipientEffect.requestDoMoralNational,
                objReq
            ).then((data: any) => {
                this.redirectRegistration(data, params, getState);
            });
        };
    }

    public static requestDoMoralInternational(params: any, opKey: string, token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                sig: params.sig,
                opk: opKey,
                token: token,
                jwt: params.jwt,
                app: params.app,
                tpp: params.tpp,
                tpc: params.tpc,
                cry: params.cry,
                acc: params.acc,
                ali: params.ali,
                raz: params.raz,
                ban: params.ban,
                ema: params.ema,
                tba: params.tba,
                cba: params.cba,
                stn: params.stn,
                rou: params.rou,
                sbl: params.sbl,
                aal: params.aal,
                ale: params.ale,
                cou: params.cou,
                tci: params.tci,
                cbi: params.cbi,
                tbi: params.tbi,
                ain: params.ain,
                trk: params.trk,
                ttx: params.ttx,
                nac: params.nac,
                suc: params.suc,
                cpo: params.cpo,
                con: params.con,
            };
            await ActionUtility.createThunkEffect<PersonResponse>(
                dispatch,
                RecipientAction.REQUEST_DO_MORAL_INTERNATIONAL_FXN,
                RecipientEffect.requestDoMoralInternational,
                objReq
            ).then((data: any) => {
                this.redirectRegistration(data, params, getState);
            });
        };
    }

    public static requestDoGetDataRecipient(params: any): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                jwt: params.jwt,
                rid: params.rid,
            };
            await ActionUtility.createThunkEffect<PersonResponse>(
                dispatch,
                RecipientAction.REQUEST_DO_GET_DATA_RECIPIEN_FXN,
                RecipientEffect.requestDoGetDataRecipient,
                objReq
            ).then((data: any) => {
                const handshake = getState().handshake.handshake;
                if (handshake && handshake.challengeUrls) {
                    if (handshake.challengeUrls.onSuccessRedirect && data.message === 'SUCCESS') {
                    } else {
                        if (handshake.challengeUrls.onErrorRedirect) {
                            let error = 'Hubo un error al cargar información del destinatario';
                            if ('errors' in data.raw.data) {
                                error = data.raw.data.errors[0].description;
                            } else if ('errorMessage' in data.raw.data) {
                                error = data.raw.data.errorMessage;
                            } else if ('error' in data.raw.data) {
                                error = data.raw.data.error;
                            } else if ('message' in data.raw.data) {
                                // The message attribute is part of the b3Servicesv2 custom exception
                                error = data.raw.data.message;
                            } else if ('code' in data.raw.data) {
                                error = `${data.raw.data.code}`;
                            }
                            window.location.href = `${handshake.challengeUrls.onErrorRedirect}/?res=false&msg=${error}&rid=${params.rid}&ttx=${params.ttx}`;
                        }
                    }
                }
            });
        };
    }

    public static requestDoDeleteRecipient(params: any, opKey: string, token: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            const objReq = {
                opk: opKey,
                token: token,
                jwt: params.jwt,
                rid: params.rid,
                ttx: params.ttx,
            };
            await ActionUtility.createThunkEffect<any>(
                dispatch,
                RecipientAction.REQUEST_DO_DELETE_RECIPIEN_FXN,
                RecipientEffect.requestDoDeleteRecipient,
                objReq
            ).then((data: any) => {
                const handshake = getState().handshake.handshake;
                if (handshake && handshake.challengeUrls) {
                    if (handshake.challengeUrls.onSuccessRedirect && data.message === 'SUCCESS' && data.data.id !== undefined) {
                        window.location.href = `${handshake.challengeUrls.onSuccessRedirect}/?res=true&msg=Se ha eliminado satisfactoriamente&ttx=${params.ttx}&recipientId=${params.rid}&currency=${params.cry}`;
                    } else {
                        if (handshake.challengeUrls.onErrorRedirect) {
                            let error = 'Hubo un error al eliminar el destinatario';

                            if ('errors' in data.raw.data) {
                                error = data.raw.data.errors[0].description;
                            } else if ('errorMessage' in data.raw.data) {
                                error = data.raw.data.errorMessage;
                            } else if ('error' in data.raw.data) {
                                error = data.raw.data.error;
                            } else if ('message' in data.raw.data) {
                                // The message attribute is part of the b3Servicesv2 custom exception
                                error = data.raw.data.message;
                            } else if ('code' in data.raw.data) {
                                error = `${data.raw.data.code}`;
                            }
                            window.location.href = `${handshake.challengeUrls.onErrorRedirect}/?res=false&msg=${error}&rid=${params.rid}&ttx=${params.ttx}`;
                        }
                    }
                }
            });
        };
    }

    static SetEmptyData(): any {
        return ActionUtility.createAction(RecipientAction.SET_EMPTY_DATA_RECIPIENT, null);
    }

    static redirectRegistration(data: any, params: any, getState: () => IStore): any {
        const handshake = getState().handshake.handshake;
        if (handshake && handshake.challengeUrls) {
            if (handshake.challengeUrls.onSuccessRedirect && data.message === 'SUCCESS' && data.data.id !== undefined) {
                window.location.href = `${handshake.challengeUrls.onSuccessRedirect}/?res=true&msg=${data.message}&trk=${params.trk}&ttx=${params.ttx}&recipientId=${data.data.id}&recipientStatus=${data.data.recipient_status}&currency=${params.cry}`;
            } else {
                if (handshake.challengeUrls.onErrorRedirect) {
                    let error;
                    if ('errors' in data.raw.data) {
                        error = data.raw.data.errors[0].description;
                        this.CODES_RETURN.forEach((catalogError) => {
                            if (data.raw.data.errors[0].code.replace(/\s/g, '').indexOf(catalogError.replace(/\s/g, '')) !== -1) {
                                error = catalogError;
                            }
                        });
                    } else if ('errorMessage' in data.raw.data) {
                        error = data.raw.data.errorMessage;
                    } else if ('error' in data.raw.data) {
                        error = data.raw.data.error;
                    } else if ('message' in data.raw.data) {
                        // The message attribute is part of the b3Servicesv2 custom exception
                        error = data.raw.data.message;
                    } else if ('code' in data.raw.data) {
                        error = `${data.raw.data.code}`;
                    }
                    window.location.href = `${handshake.challengeUrls.onErrorRedirect}/?res=false&msg=${error}&trk=${params.trk}&ttx=${params.ttx}`;
                }
            }
        }
    }
}
